import React from "react";
import { Modal } from "antd";
import Api from "../../services/ServiceApi";
import ApproveProcessLog from "./approve_process_log";
export default function ApproveProcessLogModal({
  title = "Approve Log",
  header,
  visible,
  sendData,
  callbackFunction,
  wrapClassName = "bbtec-theme",
}) {
  return (
    <>
      <Modal
        title={
          <>
            <img
              src={Api.absoluteUrl(`/icon/bbtec/body/approve.svg`)}
              alt={title}
              title={title}
            />
            <h4>{title}</h4>
          </>
        }
        footer={null}
        centered
        width={"80%"}
        visible={visible}
        onCancel={() => callbackFunction()}
        wrapClassName={wrapClassName + " approve-log-modal"}
      >
        <ApproveProcessLog sendData={sendData} header={header}></ApproveProcessLog>
      </Modal>
    </>
  );
}
